// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d58cc19","455":"58fa7c1a","977":"a47a31b6"}[chunkId] + ".chunk.js";
};